<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Imprimir clientes</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">
          <FloatLabel label="Vendedor" clase="col-12">
            <select
              id="vendedor"
              class="form-control"
              :class="(enviado && !$v.vendedor_id.required) ? 'is-invalid' : ''"
              v-model="vendedor_id"
            >
              <option :value="null">Todos</option>
              <option v-for="vendedor in vendedores" :key="vendedor.id" :value="vendedor.id">{{vendedor.nombre}}</option>
            </select>
          </FloatLabel>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
          <div class="col-md-4 offset-md-4">
            <button class="btn btn-info btn-block mb-2" @click="mostrarPDF">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
export default {
  name: "modalListadoClientes",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      vendedor_id: null,
      vendedores: [],
      enviado: false
    };
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  mounted() {
    this.getVendedores();
  },
  methods: {
    getVendedores() {
        axios.get('/users')
        .then((res) => {
            this.vendedores = res.data;
        })
    },
    mostrarPDF() {
      this.enviado = true;
      let url =
        axios.defaults.baseURL + '/imprimir/clientes-empleado?empleado='+(this.vendedor_id ?? '');
      window.open(url);
      this.cerrarModal();
    },
    cerrarModal() {
      this.$emit("cerrarListadoClientes");
    }
  }
};
</script>
